<template>
  <div v-if="isShowing" class="dd-m-popup dd-m-popup--pwa">
    <picture class="dd-m-popup--pwa__img">
      <img srcset="/assets/site/images/montagem/pwa-popup.png" alt="Baixe Agora" />
    </picture>

    <div class="dd-m-popup--pwa__content">
      <h2 class="dd-m-popup--pwa__title">WITHOUT INTERNET? SMOOTHLY!—</h2>
      <h3
        class="dd-m-popup--pwa__subtitle"
      >Conteúdo e Informação, sempre que você quiser. Instale o nosso App e fique atento às novidades.</h3>

      <div
        v-on:click.prevent="showModal"
        class="dd-m-button dd-m-button--auto dd-m-button--gray"
      >Baixar Agora</div>
    </div>

    <button v-on:click.prevent="toggle(false)" type="button" class="dd-m-popup--pwa__close-btn">
      <i class="dd-m-icon icon-close"></i>
    </button>
  </div>
</template>
<script>
export default {
  name: "pwa-popup",
  data() {
    return {
      isShowing: false
    };
  },
  mounted() {
    this.initActions();
  },
  methods: {
    showModal() {
      PubSub.publish("toggleOfflineModalTutorial", true);
    },
    toggle(show) {
      this.isShowing = show;
    },
    initActions() {
      PubSub.subscribe("togglePwaPopup", (msg, show) => this.toggle(show));
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/site/js/components/pwa-popup.vue